export default [
  { name: 'Republic of Adygeya', code: 'AD' },
  { name: 'Altai Republic', code: 'AL' },
  { name: 'Altai Krai', code: 'ALT' },
  { name: 'Amur Oblast', code: 'AMU' },
  { name: 'Arkhangelsk Oblast', code: 'ARK' },
  { name: 'Astrakhan Oblast', code: 'AST' },
  { name: 'Republic of Bashkortostan', code: 'BA' },
  { name: 'Belgorod Oblast', code: 'BEL' },
  { name: 'Bryansk Oblast', code: 'BRY' },
  { name: 'Republic of Buryatia', code: 'BU' },
  { name: 'Chechen Republic', code: 'CE' },
  { name: 'Chelyabinsk Oblast', code: 'CHE' },
  { name: 'Chukotka Autonomous Okrug', code: 'CHU' },
  { name: 'Chuvash Republic', code: 'CU' },
  { name: 'Republic of Dagestan', code: 'DA' },
  { name: 'Republic of Ingushetia', code: 'IN' },
  { name: 'Irkutsk Oblast', code: 'IRK' },
  { name: 'Ivanovo Oblast', code: 'IVA' },
  { name: 'Jewish Autonomous Oblast', code: 'YEV' },
  { name: 'Kabardino-Balkarian Republic', code: 'KB' },
  { name: 'Kaliningrad Oblast', code: 'KGD' },
  { name: 'Republic of Kalmykia', code: 'KL' },
  { name: 'Kaluga Oblast', code: 'KLU' },
  { name: 'Kamchatka Krai', code: 'KAM' },
  { name: 'Karachay–Cherkess Republic', code: 'KC' },
  { name: 'Republic of Karelia', code: 'KR' },
  { name: 'Kemerovo Oblast', code: 'KEM' },
  { name: 'Khabarovsk Krai', code: 'KHA' },
  { name: 'Republic of Khakassia', code: 'KK' },
  { name: 'Khanty-Mansi Autonomous Okrug', code: 'KHM' },
  { name: 'Kirov Oblast', code: 'KIR' },
  { name: 'Komi Republic', code: 'KO' },
  { name: 'Kostroma Oblast', code: 'KOS' },
  { name: 'Krasnodar Krai', code: 'KDA' },
  { name: 'Krasnoyarsk Krai', code: 'KYA' },
  { name: 'Kurgan Oblast', code: 'KGN' },
  { name: 'Kursk Oblast', code: 'KRS' },
  { name: 'Leningrad Oblast', code: 'LEN' },
  { name: 'Lipetsk Oblast', code: 'LIP' },
  { name: 'Magadan Oblast', code: 'MAG' },
  { name: 'Mari El Republic', code: 'ME' },
  { name: 'Republic of Mordovia', code: 'MO' },
  { name: 'Moscow', code: 'MOW' },
  { name: 'Moscow Oblast', code: 'MOS' },
  { name: 'Murmansk Oblast', code: 'MUR' },
  { name: 'Nizhny Novgorod Oblast', code: 'NIZ' },
  { name: 'Novgorod Oblast', code: 'NGR' },
  { name: 'Novosibirsk Oblast', code: 'NVS' },
  { name: 'Omsk Oblast', code: 'OMS' },
  { name: 'Orenburg Oblast', code: 'ORE' },
  { name: 'Oryol Oblast', code: 'ORL' },
  { name: 'Penza Oblast', code: 'PNZ' },
  { name: 'Perm Krai', code: 'PER' },
  { name: 'Primorsky Krai', code: 'PRI' },
  { name: 'Pskov Oblast', code: 'PSK' },
  { name: 'Rostov Oblast', code: 'ROS' },
  { name: 'Ryazan Oblast', code: 'RYA' },
  { name: 'Saint Petersburg', code: 'SPE' },
  { name: 'Sakha Republic (Yakutia)', code: 'SA' },
  { name: 'Sakhalin Oblast', code: 'SAK' },
  { name: 'Samara Oblast', code: 'SAM' },
  { name: 'Saratov Oblast', code: 'SAR' },
  { name: 'Republic of North Ossetia–Alania', code: 'SE' },
  { name: 'Smolensk Oblast', code: 'SMO' },
  { name: 'Stavropol Krai', code: 'STA' },
  { name: 'Sverdlovsk Oblast', code: 'SVE' },
  { name: 'Tambov Oblast', code: 'TAM' },
  { name: 'Republic of Tatarstan', code: 'TA' },
  { name: 'Tomsk Oblast', code: 'TOM' },
  { name: 'Tula Oblast', code: 'TUL' },
  { name: 'Tver Oblast', code: 'TVE' },
  { name: 'Tyumen Oblast', code: 'TYU' },
  { name: 'Tyva Republic', code: 'TY' },
  { name: 'Udmurtia', code: 'UD' },
  { name: 'Ulyanovsk Oblast', code: 'ULY' },
  { name: 'Vladimir Oblast', code: 'VLA' },
  { name: 'Volgograd Oblast', code: 'VGG' },
  { name: 'Vologda Oblast', code: 'VLG' },
  { name: 'Voronezh Oblast', code: 'VOR' },
  { name: 'Yamalo-Nenets Autonomous Okrug', code: 'YAN' },
  { name: 'Yaroslavl Oblast', code: 'YAR' },
  { name: 'Zabaykalsky Krai', code: 'ZAB' }
];
